define('modules/player/media/local/zone_media_collection_item_view',[
  'backbone',
  'jquery',
  '_',
  'session',

  'modules/util/collection/collection_view',
  'modules/htmlad/player/htmlad_player_view',
  'modules/modal/modal_view',
  'modules/player/media/local/modal/disconnect_last_zone_modal_view',

  'text!./zone_media_header_template.html',
  'text!./zone_media_list_item_template.html'
], function (Backbone, $, _, session,
             CollectionView,
             HtmlAdPlayer,
             ModalView,
             DisconnectLastZoneModalView,
             header_template,
             list_item_template,
             list_item_actions_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.viewType = (this.viewType) ? this.viewType : CollectionView.LIST;

      this.listenTo(this.model, 'change:confirm-removal', function (model) {
        this.$('.delete-item')[model.get('confirm-removal') ? 'addClass' : 'removeClass']('confirm');
      }, this);

      this.render();
    },

    subViews: [],
    tagName: 'div',

    list_item_template: _.template(list_item_template),
    list_item_action_template: _.template(list_item_actions_template),

    events: {
      'click .js-disconnect-item': 'clickDisconnectAdFromZone',
      'click .js-preview-ad': 'previewAd'
    },

    render: function () {
      var json = this.model.toJSON();
      $.extend(json, this.extraParams);

      this.$el.html(this.list_item_template(json));

      return this;
    },

    previewAd: function (e) {
      e.preventDefault();
      var $item = $(e.currentTarget).closest('.player-items');
      var mediaFormat = $item.data('media-format');

      if(mediaFormat === 'html') {
        this.previewHtmlAd();
      }
    },

    previewHtmlAd: function () {
      var self = this;

      var htmlAdPlayer = new HtmlAdPlayer({
        model: self.model,
        fitHeight: 600,
        close: function () {
          self.$('.js-preview-ad-container').removeClass('ad-preview').empty();
          this.remove();

        }
      });
      this.$('.js-preview-ad-container').html(htmlAdPlayer.$el).addClass('ad-preview');

      //toggle buttons
      this.$('.js-preview-htmlad').addClass('is-hidden');
      this.$('.js-edit-htmlad').removeClass('is-hidden');

      // toggle form
      this.$('.js-form-content').addClass('is-hidden');
      // and buttons
      this.$('.form-buttons').addClass('is-hidden');
    },

    clickDisconnectAdFromZone: function (e) {
      e.preventDefault();
      var t = setTimeout(function () {
        this.model.set('confirm-removal', false);
      }.bind(this), 3000);

      if (this.model.get('confirm-removal')) {
        clearTimeout(t);
        this.disconnectAdFromZone(false);
      } else {
        this.model.set('confirm-removal', true);
      }
    },

    disconnectAdFromZone: function (override_warnings) {
      var dataPayload = {};

      if (override_warnings) {
        dataPayload = {override_warnings: true};
      }

      $.ajax({
        type: 'POST',
        contentType: 'application/json; charset=UTF-8',
        url: session.get('apiUrl') + 'htmladlocation/' + this.model.get('id') + '/removezone/' + this.extraParams.zone_id,
        data: JSON.stringify(dataPayload),
        dataType: 'json'
      }).success(function (data) {
        if (data.deleted) {
          this.$el.fadeOut(200);
          setTimeout(function () {
            this.remove();
          }.bind(this), 200);
        } else {
          var disconnectModal = new ModalView({
            title: _.t('modal.header.disconnect_ad_from_last_zone'),
            modalContent: new DisconnectLastZoneModalView({messageText: _.t('modal.text.disconnect_ad_from_last_zone')})
          });

          disconnectModal.open();

          this.listenToOnce(disconnectModal.modalContent, 'disconnectAd', function () {
            this.disconnectAdFromZone(true);
          });
        }

      }.bind(this));
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.remove();
      this.stopListening();
      return this;
    }

  }, {
    header: function (collection) {
      return _.template(header_template)(collection.params);
    },
    viewTypes: [CollectionView.LIST]
  });
  return View;
});

